// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Eye } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconEye(props: any) {
    return <IconBase icon={Eye} {...props} />
  }

  export default IconEye
  